"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewbuildingsList = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./NewbuildingsList.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NewbuildingsList = props => {
  const {
    newbuildings,
    listingUrl,
    onListingLinkClick,
    onNewbuildingClick,
    newbuildingCountText
  } = props;
  const deviceType = (0, _uiKit.useDeviceType)();
  const listingLinkTitle = React.useMemo(() => {
    return deviceType === 'desktop' ? 'Смотреть все' : 'Все';
  }, [deviceType]);
  const title = React.useMemo(() => {
    if (newbuildingCountText) {
      return newbuildingCountText;
    }
    return `Акция проходит в ${newbuildings.length} ЖК`;
  }, [newbuildingCountText, newbuildings]);
  if (newbuildings.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, title), listingUrl && /*#__PURE__*/React.createElement(_uiKit.Link, {
    fontWeight: "bold",
    afterIcon: /*#__PURE__*/React.createElement(_uiKit.IconChevronRightSmall16, {
      color: "icon-main-default"
    }),
    href: listingUrl,
    onClick: onListingLinkClick,
    target: "_blank"
  }, listingLinkTitle)), /*#__PURE__*/React.createElement("div", {
    className: style['list']
  }, newbuildings.filter(newbuilding => newbuilding.link && newbuilding.name).map((newbuilding, index) => /*#__PURE__*/React.createElement("a", {
    key: index,
    className: style['item'],
    href: newbuilding.link,
    target: "_blank",
    rel: "noreferrer",
    onClick: onNewbuildingClick
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, newbuilding.name), /*#__PURE__*/React.createElement("div", {
    className: style['icon']
  }, /*#__PURE__*/React.createElement(_uiKit.IconChevronRight16, null))))));
};
exports.NewbuildingsList = NewbuildingsList;